import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { SectionTag } from './ui/SectionTag';
import { CTAButton } from './ui/CTAButton';
import { CheckItem } from './ui/CheckItem';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
const baseIncludes = ['5 Tomos', '250+ páginas', '5 Bonos', 'Fichas de Pista', 'Radar del Alumno', 'Correcciones Rápidas', 'Planificador 30 Días', 'Vuelta a Pista'];
const kitIncludes = ['Todo Maestro en Pista', 'Los 5 Tomos', 'Los 5 Bonos', 'El Mapa de Pista', '50 Esquemas Técnicos', 'Programador 12 Meses'];
export function PricingCards() {
  return <section id="oferta" className="bg-mp-black py-20 md:py-28 scroll-mt-20" data-id="element-228" data-mp="2p4fk2wjzcmuc">
      <Container data-id="element-229" data-mp="2p6jln7uep9rg">
        <div className="mx-auto max-w-[700px] text-center" data-id="element-230" data-mp="2u41xb5zt6335">
          <SectionTag tone="lime" data-id="element-231" data-mp="2u5mt0yxuzs2l">Elige cómo quieres trabajar</SectionTag>
          <h2 className="mt-5 font-heading text-3xl uppercase leading-tight text-mp-white sm:text-4xl md:text-5xl" data-id="element-232" data-mp="2z3y0x44lfsi6">
            Dos opciones. Un mismo objetivo: dejar de improvisar.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-233" data-mp="3oh1n0v49lyhc">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="flex flex-col rounded-2xl border border-mp-border bg-mp-card p-7 md:p-8" data-id="element-234" data-mp="3jjrsj120qwmn">
            <p className="font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-235" data-mp="b3ou7lwsqkaz">Maestro en Pista</p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-236" data-mp="6a3vfrndpmaq">Para aprender y aplicar el sistema</p>

            <ul className="mt-6 space-y-2.5" data-id="element-237" data-mp="2acz78f32dyt">
              {baseIncludes.map(item => <CheckItem key={item} data-id="element-238" data-mp="ytsnazccz1nq">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-239" data-mp="u07y9wsqti0o" />

            <p className="font-heading text-4xl text-mp-white" data-id="element-240" data-mp="2o9mu2igfygu1">17,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-241" data-mp="2obpvdyn1nwe2">Pago único</p>

            <CTAButton href="#comparacion" variant="secondary" className="mt-6 w-full" showArrow data-id="element-242" data-mp="2tasnkihxe84m">
              Quiero la versión base
            </CTAButton>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="relative flex flex-col rounded-2xl border-2 border-mp-lime bg-mp-card p-7 shadow-glow-lime md:p-8" data-id="element-243" data-mp="2jhbslb61ymzd">
            <span className="absolute -top-3 left-7 rounded-full bg-mp-lime px-3 py-1 font-heading text-[10px] font-bold uppercase tracking-wide text-mp-black" data-id="element-244" data-mp="20l3nc7d1ic42">
              Recomendado para monitores en activo
            </span>

            <p className="mt-2 font-heading text-lg uppercase tracking-wide text-mp-white" data-id="element-245" data-mp="3uxa89xvqk79k">
              Maestro en Pista + Kit de Ejecución
            </p>
            <p className="mt-1 text-sm text-mp-gray" data-id="element-246" data-mp="1ecepx5we0m30">Para tener el sistema + la infraestructura</p>

            <ul className="mt-6 space-y-2.5" data-id="element-247" data-mp="1t0syzyked6s0">
              {kitIncludes.map(item => <CheckItem key={item} data-id="element-248" data-mp="1o9b3hq157yef">{item}</CheckItem>)}
            </ul>

            <div className="mt-8 flex-1" data-id="element-249" data-mp="220y0js2wtay9" />

            <p className="font-heading text-4xl text-mp-lime" data-id="element-250" data-mp="21zmv7nttfv51">23,90 €</p>
            <p className="font-heading text-xs uppercase tracking-[0.18em] text-mp-gray" data-id="element-251" data-mp="1y0e3spm909cn">
              Solo 6 € más que la versión base
            </p>

            <CTAButton href="#comparacion" className="mt-6 w-full" showArrow data-id="element-252" data-mp="2bx1b9mbtuhwt">
              Quiero el sistema completo
            </CTAButton>
          </motion.div>
        </div>
      </Container>
    </section>;
}